import { render, staticRenderFns } from "./vechicle-identity.vue?vue&type=template&id=0c82e689&scoped=true"
import script from "./vechicle-identity.vue?vue&type=script&lang=js"
export * from "./vechicle-identity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c82e689",
  null
  
)

export default component.exports